import ProductLabel from './ProductLabel';

export default ProductLabel;
